import { Box, Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { HOME_LAYOUT_HEIGHT } from "../../app/common";
import { FeatureFlagName } from "../../app/featureFlags/featureFlags";
import { canViewFeature } from "../../app/featureFlags/helpers";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { routes } from "../../app/paths";
import { canExpertUseMessaging } from "../user/accessRightChecks";
import AddParticipantDialog from "./AddParticipantDialog";
import MessagingConversation from "./conversation/MessagingConversation";
import MessagingInbox from "./inbox/MessagingInbox";
import MessagingMaintenance from "./MessagingMaintenance";
import {
  selectMessagingServiceUnavailable,
  setFloatingWindowOpen,
} from "./messagingSlice";
import useMessagingInboxSession from "./useMessagingInboxSession";

const MessagingPage = () => {
  const dispatch = useAppDispatch();
  const [addParticipantDialogOpen, setAddParticipantDialogOpen] =
    useState(false);
  const user = useAppSelector((state) => state.user.user);
  const serviceUnavailable = useAppSelector(selectMessagingServiceUnavailable);
  const canViewMessaging =
    canViewFeature(FeatureFlagName.MESSAGING, user) &&
    canExpertUseMessaging(user);

  const {
    tabIndex,
    handleTabChange,
    loadMore,
    selectedParticipant,
    onConversationChange,
    handleAddParticipant,
    allowedRecipientTypes,
  } = useMessagingInboxSession({
    enabled: canViewMessaging && !serviceUnavailable,
    clearSelectionOnUnmount: true,
  });

  useEffect(() => {
    dispatch(setFloatingWindowOpen(false));
  }, [dispatch]);

  if (!canViewMessaging) {
    return <Navigate to={routes.home()} replace />;
  }

  if (serviceUnavailable) {
    return <MessagingMaintenance />;
  }

  return (
    <Box
      data-testid="messaging-page-root"
      sx={{
        maxWidth: "1300px",
        height: HOME_LAYOUT_HEIGHT,
        backgroundColor: "#fff",
        borderRadius: "8px",
      }}
    >
      <Grid container direction="row" wrap="nowrap" sx={{ height: "100%" }}>
        <MessagingInbox
          tabIndex={tabIndex}
          handleTabChange={handleTabChange}
          initializeNewConversation={() => setAddParticipantDialogOpen(true)}
          onConversationChange={onConversationChange}
          loadMore={loadMore}
        />
        <MessagingConversation
          participant={selectedParticipant}
          handleTabChange={handleTabChange}
        />
      </Grid>
      <AddParticipantDialog
        open={addParticipantDialogOpen}
        onClose={() => setAddParticipantDialogOpen(false)}
        allowedRecipientTypes={allowedRecipientTypes}
        onConfirm={(participant) => {
          setAddParticipantDialogOpen(false);
          handleAddParticipant(participant);
        }}
      />
    </Box>
  );
};

export default MessagingPage;
